import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services';
import { Router, ActivatedRoute } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { VerifyUser, MakeNewPassw } from 'src/app/services/account-mutations';
import { AccountService } from 'src/app/services/account.service';

type ResponseType = {
  success: boolean;
  message: string;
};

type VerifiedMutation = {
  response: ResponseType;
};

type VerifyUserResponse = {
  verifiedUser: VerifiedMutation;
};

type LostPasswordMutation = {
  response: ResponseType;
};

type MakeNewPasswResponse = {
  makeNewPassw: LostPasswordMutation;
};

@Component({
  selector: 'app-make-passw',
  templateUrl: './make-passw.component.html',
  styleUrls: ['./make-passw.component.css']
})
export class MakePasswComponent implements OnInit {
  form: FormGroup;
  hide: boolean;
  loading: boolean;
  tokenPassw: string;
  isLostMode: boolean;

  constructor(private formBuilder: FormBuilder, private alertService: AlertService, private apollo: Apollo, private router: Router, private route: ActivatedRoute) {
    this.form = this.formBuilder.group({
      password1: ['', [Validators.required, Validators.minLength(8)]],
      password2: ['', [Validators.required, Validators.minLength(8)]]
    });
    this.isLostMode = false;
    this.hide = true;
    this.loading = false;
    this.tokenPassw = this.route.snapshot.paramMap.get('token')!;
    if (this.route.snapshot.url[1].path == "lost")
      this.isLostMode = true;
  }

  ngOnInit(): void {
  }

  getFieldPass1Error() {
    if (this.form.controls["password1"].hasError('required')) {
      return 'You must enter a value';
    } else {
      return 'Length must be greater than 7';
    }
  }

  getFieldPass2Error() {
    if (this.form.controls["password2"].hasError('required')) {
      return 'You must enter a value';
    } else {
      return 'Length must be greater than 7';
    }
  }

  onSubmit() {
    if (this.form.controls["password1"].value != this.form.controls["password2"].value) {
      this.alertService.error("Passwords must be the same.");
    } else {
      this.alertService.clear();
      this.loading = true;
      if (this.isLostMode) {
        this.apollo
          .mutate({
            mutation: MakeNewPassw,
            variables: {
              passw1: this.form.controls["password1"].value,
              passw2: this.form.controls["password2"].value,
              tokenPassw: this.tokenPassw
            }
          })
          .subscribe({
            next: ({ data, loading }) => {
              let data_resp: MakeNewPasswResponse  = data as MakeNewPasswResponse;
              if (data_resp.makeNewPassw.response.success) {
                this.alertService.success('Operation completed', { keepAfterRouteChange: true });
                this.router.navigate(['/account/login']);
              } else {
                this.alertService.error(data_resp.makeNewPassw.response.message);
              }
              this.loading = loading ?? false;
            },
            error: (error) => {
              console.log('there was an error sending the query', error)
              this.alertService.error(error);
              this.loading = false;
            }
          });
      } else {
        this.apollo
          .mutate({
            mutation: VerifyUser,
            variables: {
              passw1: this.form.controls["password1"].value,
              passw2: this.form.controls["password2"].value,
              tokenPassw: this.tokenPassw
            }
          })
          .subscribe({
            next: ({ data, loading }) => {
              let data_resp: VerifyUserResponse = data as VerifyUserResponse;
              if (data_resp.verifiedUser.response.success) {
                this.alertService.success('Registration completed', { keepAfterRouteChange: true });
                this.router.navigate(['/account/login']);
              } else {
                this.alertService.error(data_resp.verifiedUser.response.message);
              }
              this.loading = loading ?? false;
            },
            error: (error) => {
              console.log(error);
              let first: string = String(error).replace('[', '');
              let second: string = first.replace(']', '');
              let test: string = second.replace('Error:', '');
              let third: string = test.split("'").join('');
              let error_array: string[] = third.split(',');
              for(let pos in error_array) {
                this.alertService.error(error_array[pos]);
              }
              this.loading = false;
            }
          });
      }
    }
  }

}
